// Dummy data for Company Definition Form testing
export const companyDefinitionDummyData = {
  // Basic Company Information
  name: "TechCorp Solutions Pvt Ltd",
  address1: "123 Business Park, Sector 15",
  address2: "Near Metro Station, Floor 5",
  place: "Gurgaon",
  city: "Gurgaon",
  state: "Haryana",
  pinCode: "122001",
  stdCode: "0124",
  faxNo: "0124-1234567",
  
  // Contact Information
  payrollManager: "Rajesh Kumar",
  email: "payroll@techcorp.com",
  PANno: "AABCT1234D",
  TANno: "DELH12345A",
  
  // Management Information
  CFOname: "Priya Sharma",
  fathersName: "Suresh Kumar",
  designation: "Senior Manager",
  
  // Tax Information
  professionTax: "5000",
  
  // Login Credentials
  userName: "admin@techcorp.com",
  password: "TechCorp@2024",
  confirmPassword: "TechCorp@2024"
};

// Additional dummy data sets for testing different scenarios
export const companyDefinitionDummyDataSets = [
  {
    id: 1,
    name: "Global Tech Industries",
    address1: "456 Corporate Tower, MG Road",
    address2: "Suite 200, 2nd Floor",
    place: "Bangalore",
    city: "Bangalore",
    state: "Karnataka",
    pinCode: "560001",
    stdCode: "080",
    faxNo: "080-9876543",
    payrollManager: "Anita Singh",
    email: "hr@globaltech.com",
    PANno: "BBBCD5678E",
    TANno: "BANG67890B",
    CFOname: "Vikram Patel",
    fathersName: "Ramesh Patel",
    designation: "Director",
    professionTax: "7500",
    userName: "admin@globaltech.com",
    password: "GlobalTech@2024",
    confirmPassword: "GlobalTech@2024"
  },
  {
    id: 2,
    name: "Innovation Hub Ltd",
    address1: "789 Startup District",
    address2: "Building A, Unit 301",
    place: "Pune",
    city: "Pune",
    state: "Maharashtra",
    pinCode: "411001",
    stdCode: "020",
    faxNo: "020-5555555",
    payrollManager: "Sneha Reddy",
    email: "payroll@innovationhub.com",
    PANno: "CCCDE9012F",
    TANno: "PUNE12345C",
    CFOname: "Arjun Mehta",
    fathersName: "Kumar Mehta",
    designation: "CFO",
    professionTax: "3000",
    userName: "admin@innovationhub.com",
    password: "Innovation@2024",
    confirmPassword: "Innovation@2024"
  },
  {
    id: 3,
    name: "Manufacturing Solutions Inc",
    address1: "Industrial Area, Phase 2",
    address2: "Plot No. 45, Sector 20",
    place: "Noida",
    city: "Noida",
    state: "Uttar Pradesh",
    pinCode: "201301",
    stdCode: "0120",
    faxNo: "0120-4444444",
    payrollManager: "Deepak Verma",
    email: "hr@manufacturing.com",
    PANno: "DDDEF3456G",
    TANno: "NOIDA56789D",
    CFOname: "Sunita Gupta",
    fathersName: "Rajesh Gupta",
    designation: "Finance Head",
    professionTax: "10000",
    userName: "admin@manufacturing.com",
    password: "Manufacturing@2024",
    confirmPassword: "Manufacturing@2024"
  },
  {
    id: 4,
    name: "Digital Services Co",
    address1: "IT Park, Electronic City",
    address2: "Tower B, 15th Floor",
    place: "Chennai",
    city: "Chennai",
    state: "Tamil Nadu",
    pinCode: "600100",
    stdCode: "044",
    faxNo: "044-3333333",
    payrollManager: "Kavitha Nair",
    email: "payroll@digitalservices.com",
    PANno: "EEEFG7890H",
    TANno: "CHEN90123E",
    CFOname: "Ravi Krishnan",
    fathersName: "Srinivasan Krishnan",
    designation: "Chief Financial Officer",
    professionTax: "6000",
    userName: "admin@digitalservices.com",
    password: "Digital@2024",
    confirmPassword: "Digital@2024"
  },
  {
    id: 5,
    name: "Healthcare Systems Pvt Ltd",
    address1: "Medical District, Sector 12",
    address2: "Block C, Room 205",
    place: "Hyderabad",
    city: "Hyderabad",
    state: "Telangana",
    pinCode: "500001",
    stdCode: "040",
    faxNo: "040-2222222",
    payrollManager: "Dr. Meera Rao",
    email: "hr@healthcare.com",
    PANno: "FFFGH1234I",
    TANno: "HYDE23456F",
    CFOname: "Dr. Anil Kumar",
    fathersName: "Dr. Suresh Kumar",
    designation: "Medical Director",
    professionTax: "8000",
    userName: "admin@healthcare.com",
    password: "Healthcare@2024",
    confirmPassword: "Healthcare@2024"
  }
];

// Field validation examples
export const fieldValidationExamples = {
  valid: {
    email: "test@company.com",
    PANno: "ABCDE1234F",
    TANno: "DELH12345A",
    pinCode: "110001",
    stdCode: "011",
    faxNo: "011-1234567"
  },
  invalid: {
    email: "invalid-email",
    PANno: "INVALID123",
    TANno: "WRONG123",
    pinCode: "123",
    stdCode: "abc",
    faxNo: "invalid-fax"
  }
};

// State and city combinations for testing
export const stateCityCombinations = [
  { state: "Delhi", city: "New Delhi", pinCode: "110001" },
  { state: "Maharashtra", city: "Mumbai", pinCode: "400001" },
  { state: "Karnataka", city: "Bangalore", pinCode: "560001" },
  { state: "Tamil Nadu", city: "Chennai", pinCode: "600001" },
  { state: "West Bengal", city: "Kolkata", pinCode: "700001" },
  { state: "Gujarat", city: "Ahmedabad", pinCode: "380001" },
  { state: "Rajasthan", city: "Jaipur", pinCode: "302001" },
  { state: "Punjab", city: "Chandigarh", pinCode: "160001" }
];

// Common Indian company names for testing
export const companyNames = [
  "ABC Technologies Pvt Ltd",
  "XYZ Industries Limited",
  "Global Solutions Inc",
  "Innovation Labs Pvt Ltd",
  "Tech Services Co",
  "Business Solutions Ltd",
  "Digital Innovations Pvt Ltd",
  "Smart Systems Inc",
  "Future Technologies Ltd",
  "Advanced Solutions Pvt Ltd"
];

// Common Indian names for testing
export const indianNames = {
  male: [
    "Rajesh Kumar",
    "Amit Sharma",
    "Vikram Singh",
    "Arjun Patel",
    "Ravi Verma",
    "Suresh Gupta",
    "Deepak Mehta",
    "Anil Kumar",
    "Rohit Sharma",
    "Kumar Singh"
  ],
  female: [
    "Priya Sharma",
    "Anita Singh",
    "Sneha Reddy",
    "Kavitha Nair",
    "Meera Rao",
    "Sunita Gupta",
    "Pooja Patel",
    "Rekha Verma",
    "Shilpa Kumar",
    "Neha Sharma"
  ]
};

// Common designations for testing
export const designations = [
  "CEO",
  "CFO",
  "Director",
  "Manager",
  "Senior Manager",
  "Finance Head",
  "HR Manager",
  "Operations Manager",
  "General Manager",
  "Vice President"
];

// Common email domains for testing
export const emailDomains = [
  "@company.com",
  "@techcorp.com",
  "@business.com",
  "@solutions.com",
  "@industries.com",
  "@services.com",
  "@systems.com",
  "@labs.com",
  "@innovations.com",
  "@digital.com"
];
